import { getDocs, where, query } from "firebase/firestore";
import { DataAccessService } from "./basic.service";

class VirtualClassesAccessService extends DataAccessService {

    constructor(collectionName: string) {
        super(collectionName)
    }

    async getBySerialDeviceNumber(serial: string) {

        const d = []
        
        const querySnapshot = await getDocs(query(this.getCollection(), where('playerId', '==', serial)));
        if (!querySnapshot.empty) {
           
            for (const document of querySnapshot.docs) {
                console.log(document.id)
                d.push({ ...document.data(), id: document.id });
            }
        }
        return d
    }


}
export default new VirtualClassesAccessService('virtual_classes');